<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>

    <article class="view__content">
      <div class="view__panel">
        <div class="view__tabs">
          <Navigation :steps="form.steps" :currentstep="form.currentstep" />
          <dropdown
              v-if="model.id"
              v-on:delete="deleteCampaign"
              v-on:duplicate="duplicateCampaign"

              :label="actions.label"
              :links="actions.links"
              acc="actions"
              :isNotSync="true">
          </dropdown>
        </div>

        <div class="multi-step">


          <div class="multi-step__step" v-if="form.currentstep == 1 && !model.showEditor">
              <CampaignInformation ref="information" :campaign="model" />
          </div>

          <div class="multi-step__step" v-if="form.currentstep == 2 && !model.showEditor">
              <CampaignTarget :campaign="model" />
          </div>

          <div class="multi-step__step" v-if="form.currentstep == 3 && !model.showEditor">
              <CampaignContent :campaign="model" />
          </div>

          <div class="multi-step__step" v-if="form.currentstep == 4 && !model.showEditor">
              <CampaignPreview :campaign="model" />
          </div>

          <div class="multi-step__step" v-if="form.currentstep == 5 && !model.showEditor">
              <CampaignSuccess :campaign="model" />
          </div>

          <Controls
                v-for="step in form.steps"
                :step="step"
                :stepcount="form.steps.length"
                :currentstep="form.currentstep"
                :nextDisabled="step.nextDisabled || disableNextButtonForContent"
                v-if="form.currentstep != 5"
                @step-change="stepChanged">
            </Controls>
        </div>
      </div>

      <div v-if="model.showEditor">
        <bee
          :clientId="tenant.beeClientId"
          :clientSecret="tenant.beeClientSecret"
          :layout="model.template"
          @onSave="saveLayout"
          @onAutoSave="onAutoSave"
        />
      </div>
    </article>

  </article>
</template>

<script>
import Dropdown from 'components/partials/Dropdown'
import { Navigation, Controls } from 'components/layout/multi-steps'
import { CampaignInformation, CampaignTarget, CampaignContent, CampaignPreview, CampaignSuccess } from 'components/views/campaigns/form'
import { TextBox, Btn } from 'components/layout/forms'
import Bee from 'components/partials/Bee'
import Submenu from 'components/views/campaigns/Submenu'
import L from 'services/Localization'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'campaign',
  components: { Dropdown, Submenu, Validation, TextBox, Btn, Navigation, Controls, CampaignInformation, CampaignTarget, CampaignContent, CampaignPreview, CampaignSuccess, Bee },
  mixins: [notifications],
  data() {
    return {
      title: 'Create',
      L: L,
      form: {
        currentstep: 1,
        step: 1,
        steps: [
          { id: 1 },
          { id: 2 },
          { id: 3 },
          { id: 4, nextDisabled: true },
          { id: 5 }
        ]
      },
      model: {
        id: '',

        // Step 1
        name: '',
        subject: '',
        fromName: '',
        fromEmail: '',

        // Step 2
        searchCriterias: [],

        // Step 3
        template: {},
        showEditor: false,
        body: '',
        config: '',

        // Step 4
        scheduledAt: ''
      },
      tenant: {
        name: '',
        description: '',
        image: {},
        beeClientId: '',
        beeClientSecret: ''
      }
    }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getCampaign', this.$route.params.id).then(() => {
        this.mapFromState()
      })

      this.$store.dispatch('getTenantSession').then(() => {
        _.assign(this.tenant, this.currentTenant)
      })
    }
  },
  beforeDestroy() {
    this.$store.dispatch('getCampaign', null)
  },
  computed: {
    ...mapGetters({
      campaign: 'activeCampaign',
      currentTenant: 'getCurrentTenant'
    }),
    disableNextButtonForContent() {
      return this.form.currentstep === 3 && _.isEmpty(this.model.config)
    },
    actions() {
      let menu = {
        label: L.localize('Label_Actions'),
        links: []
      }
      menu.links.push({
        label: L.localize('Label_Duplicate'),
        bypassRouter: true,
        asFunction: true,
        url: 'duplicate',
        acc: 'duplicate'
      })
      menu.links.push({
        label: L.localize('Label_Delete'),
        bypassRouter: true,
        asFunction: true,
        url: 'delete',
        acc: 'delete'
      })
      return menu
    }
  },
  validations: {
    model: {
      name: { required },
      subject: { required },
      scheduledAt: { required }
    }
  },
  methods: {
    mapFromState() {
      _.assign(this.model, this.campaign)
      if (_.isNull(this.campaign.searchCriterias)) {
        this.model.searchCriterias = []
      }
      if (this.campaign) {
        this.title = this.campaign.name
      }

      if (this.campaign.status === 'sent') {
        this.stepChanged(5)
      }
    },
    stepChanged(nextStep) {
      let success = false

      // no validation if user click on 'previous' button
      if (this.form.currentstep > nextStep) {
        this.form.currentstep = nextStep
        return
      }

      switch (nextStep - 1) {

        // Information
        case 1:
          if (this.$refs.information.isValid()) {
            this.save()
            success = true
          }
          break

        // Target
        case 2:
          this.save()
          success = true
          break

        // Content
        case 3:
          this.save()
          success = true
          break

          // Content
        case 4:
          success = true
          break
      }

      if (success) {
        this.form.currentstep = nextStep
      }
    },
    onAutoSave(data) {
      console.log('onAutoSave');
      this.model.config = data.json
      this.save();
    },
    saveLayout(data) {
      this.model.showEditor = false
      this.model.body = data.html
      this.model.config = data.json
      this.stepChanged(this.form.currentstep + 1)
    },
    save() {
      let campaign = this.model
      this.$store.dispatch('createOrUpdateCampaign', campaign).then(
        () => { this.mapFromState() },
        () => { window.alert('REJECT') }
      )
    },
    duplicateCampaign() {
      this.$store.dispatch('duplicateCampaign', this.model.id).then(
        () => {
          this.showNotification({
            title: L.localize('Label_SuccessCreation'),
            message: L.localize('Label_Success')
          })
          this.$router.push({name: 'campaigns'})
        },
        () => { window.alert('REJECT') }
      )
    },
    deleteCampaign() {
      this.$store.dispatch('deleteCampaign', this.model.id).then(
        () => {
          this.showNotification({
            title: L.localize('Label_SuccessDeletion'),
            message: L.localize('Label_Success')
          })
          this.$router.push({name: 'campaigns'})
        },
        () => { window.alert('REJECT') }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Campaign.vue?4317fe62